export default __webpack_public_path__ + "static/media/icon-kebab-menu.8b7eda85.svg";